import { ExperienceLevel } from "./types"

export function getDriverExperience(joinedAt: string) {
  const joinedDate = new Date(joinedAt)
  const now = new Date()

  // Calculate exact time difference
  const diffTime = Math.abs(now.getTime() - joinedDate.getTime())

  // Calculate months (using average month length of 30.44 days)
  const monthsActive = Math.floor(diffTime / (1000 * 60 * 60 * 24 * 30.44))

  // Calculate years (using exact 365 days)
  const years = Math.max(1, Math.floor(diffTime / (1000 * 60 * 60 * 24 * 365)))

  // Determine experience level
  let level: ExperienceLevel = "new"
  if (monthsActive >= 24) level = "expert"
  else if (monthsActive >= 6) level = "intermediate"

  return {
    years,
    monthsActive,
    level,
    joinYear: joinedDate.getFullYear(),
    formattedDate: joinedDate.toLocaleDateString("en-US", {
      month: "long",
      year: "numeric",
    }),
  }
}
